import { COLUMN_ROLES } from 'reporting-data/constants/relationalReports';
import { createRelationalReportFromBaseReport } from 'reporting-snowflake/relational/utils/report-utils';
import { getDataSourceId, getDataSourceIdFromTableDescription, getTableList } from 'reporting-snowflake/relational/utils/table-utils';
import { getReportDefinitionTable } from 'reporting-data/report/relationalReportGetters';
import { TableDescription } from 'reporting-snowflake/relational/schema/table-records';
import { STANDARD_FIELD_TYPES } from './shared/constants/fieldTypes';
export const RelationalReportGetterStrategy = {
  [STANDARD_FIELD_TYPES.DIMENSIONS]: report => {
    const reportDefTable = createRelationalReportFromBaseReport(report).table;
    return report.getIn(['reportDefinition', 'columns']).filter(columnMetaData => columnMetaData.get('role') === COLUMN_ROLES.DIMENSION).map(columnMetaData => {
      const objectType = columnMetaData.getIn(['field', 'table']);
      const objectTypeId = getDataSourceIdFromTableDescription(reportDefTable, objectType);
      return {
        dataType: objectTypeId,
        property: columnMetaData.getIn(['field', 'name'])
      };
    }).toList().toJS();
  },
  [STANDARD_FIELD_TYPES.METRICS]: report => {
    const reportDefTable = createRelationalReportFromBaseReport(report).table;
    return report.getIn(['reportDefinition', 'columns']).filter(columnMetaData => columnMetaData.get('role') === COLUMN_ROLES.MEASURE && !columnMetaData.get('fixedMeasure')).map(columnMetaData => {
      const objectType = columnMetaData.getIn(['field', 'table']);
      const objectTypeId = getDataSourceIdFromTableDescription(reportDefTable, objectType);
      return {
        property: columnMetaData.getIn(['field', 'name']),
        metricType: columnMetaData.get('aggregation'),
        dataType: objectTypeId
      };
    }).toList().toJS();
  },
  [STANDARD_FIELD_TYPES.DATA_TYPE]: report => report.getIn(['reportDefinition', 'table', 'objectTypeId']),
  [STANDARD_FIELD_TYPES.CHART_TYPE]: report => report.getIn(['reportDefinition', 'visual', 'type']),
  [STANDARD_FIELD_TYPES.PRIMARY_DATA_SOURCE_ID]: report => {
    const definitionTable = getReportDefinitionTable(report);
    const tableDescription = TableDescription(definitionTable.toJS());
    return getDataSourceId(tableDescription);
  },
  [STANDARD_FIELD_TYPES.ALL_DATA_SOURCE_IDS]: report => {
    const definitionTable = getReportDefinitionTable(report);
    const tableDescription = TableDescription(definitionTable.toJS());
    return getTableList(tableDescription).map(table => getDataSourceId(table), []).toJS();
  }
};